module.exports = __webpack_public_path__ + "static/media/nifty_backers.663def3b.svg";